export const EN_STRING_OVERRIDES = {
  LAUNCH_IMPERSONATION_MODE: 'Launch user simulation mode',
  WALLET: 'Benefits',
};
